import { render, staticRenderFns } from "./DonationList.vue?vue&type=template&id=9ee42fb4&"
import script from "./DonationList.vue?vue&type=script&lang=js&"
export * from "./DonationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DonationList.vue"
export default component.exports